import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';
import { DataValueMap } from 'Helpers/Testing';
import React, { useState } from 'react';
import { useSnackbarContext } from 'Context/SnackbarContext';
import PropTypes from 'prop-types';
import MemberDataCaptureCurrentActionItemLayout
  from 'Components/ComponentLibrary/Organisms/MemberDataCapture/Layouts/MemberDataCaptureCurrentActionItemLayout';

export default function MemberDataCaptureCurrentDefaultLayout({ isReadOnly }) {
  const { resource, onSubmit } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [loading, setLoading] = useState(false);

  const handleOnClick = async () => {
    try {
      setLoading(true);
      await onSubmit();
    } catch (err) {
      displayErrorMessage('Failed to submit current member data capture item');
    }
    setLoading(false);
  };

  return (
    <FDStack direction={'column'} alignItems={'stretch'} spacing={2}>
      <MetaLayoutVertical resource={resource} />
      <FDPrimaryActionButton
        {...DataValueMap.init('member-data-capture-current-submit').build()}
        label={resource.attr('primaryActionLabel') || 'Submit'}
        size={'lg'}
        isFullWidth
        disabled={isReadOnly}
        loading={loading}
        onClick={handleOnClick}
      />
    </FDStack>
  );
}

MemberDataCaptureCurrentActionItemLayout.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
};
